import { isPrivateNotesActivity } from "./privateNotesScope";
export { isPrivateNotesActivity } from "./privateNotesScope";
export const JAB_ORG_ID = "332a9d47-6e36-11e8-a392-061714f61e3e";
export const INTERNAL_NOTES_ITEM_ID = "labelInternalNotes";
const SOURCE_KEY = "internalNotesSource";

export const isInternalNotesItemId = id => typeof id === "string"
	&& (id === INTERNAL_NOTES_ITEM_ID || id.startsWith(`${INTERNAL_NOTES_ITEM_ID}_`));

export function getInternalNotesAccess(orgId, { administrator = false, internalStaff = false } = {}, activity) {
	return isPrivateNotesActivity(activity, orgId)
		? { canRead: administrator || internalStaff, canEdit: administrator }
		: null;
}

// Compatibility entry point for pricing load. Private hydration now happens
// only in the authenticated service, outside canonical/public job details.
export function hydrateJabInternalNotes(activity = {}, jobDetails = {}, orgId) {
	if (!isPrivateNotesActivity(activity, orgId)) return jobDetails;
	const { parts, internalNotesSource, ...publicDetails } = jobDetails;
	return publicDetails;
}

// Private edits use the authenticated service. Generic pricing messages cannot
// set or restore private text into canonical/public job details.
export function mergeJabInternalNotesUpdate(existing = {}, resolved = {}, incoming, access) {
	if (!access) return resolved;
	const { parts, internalNotesSource, ...publicDetails } = resolved || {};
	return publicDetails;
}

// Remove private data before crossing a customer/report boundary, including
// saved estimate/approval snapshots and the original activity answer. Do not
// remove unrelated product/component properties named "parts".
export function projectJabCustomerData(value, orgId, activity = value) {
	if (orgId !== JAB_ORG_ID) return value;
	if (Array.isArray(value) && activity === value) {
		const projected = value.map(entry => projectJabCustomerData(entry, orgId));
		return projected.every((entry, index) => entry === value[index]) ? value : projected;
	}
	return isPrivateNotesActivity(activity, orgId) ? projectPrivateData(value) : value;
}
function projectPrivateData(value, parentKey = "") {
	if (Array.isArray(value)) return value.map(entry => projectPrivateData(entry, parentKey)).filter(entry => entry !== undefined);
	if (!value || typeof value !== "object" || value instanceof Date) return value;
	if (isInternalNotesItemId(value.id)) return undefined;
	return Object.keys(value).reduce((result, key) => {
		if (key === SOURCE_KEY || isInternalNotesItemId(key) || (parentKey === "jobDetails" && key === "parts")) return result;
		const projected = projectPrivateData(value[key], key);
		if (projected !== undefined) result[key] = projected;
		return result;
	}, {});
}

// Compatibility export for older callers; do not restore private canonical data.
export function preserveJabInternalNotes(incoming, activity = incoming) {
	return projectJabCustomerData(incoming, JAB_ORG_ID, activity);
}
